import { render } from "./Notepads.vue?vue&type=template&id=64770062"
import script from "./Notepads.vue?vue&type=script&lang=js"
export * from "./Notepads.vue?vue&type=script&lang=js"

import "./Notepads.vue?vue&type=style&index=0&id=64770062&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Notepads.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64770062"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64770062', __exports__)) {
    api.reload('64770062', __exports__)
  }
  
  module.hot.accept("./Notepads.vue?vue&type=template&id=64770062", () => {
    api.rerender('64770062', render)
  })

}


export default __exports__